// src/components/CommandEditor.tsx
import React from 'react';
import { useContent } from '../contexts/ContentContext';
import ContentPageHeader from './PageHeader';
import GuideHelpButton from './GuideHelpButton';

const CommandEditor: React.FC<{ standalone?: boolean }> = ({ standalone = false }) => {
  const { t } = useContent();
  return (
    <div className={standalone ? 'lab-content-page' : 'p-4 md:p-6 bg-white dark:bg-gray-800 ivory:bg-coffee-100 rounded-lg shadow text-gray-900 dark:text-gray-100 ivory:text-coffee-800'}>
      {standalone ? <ContentPageHeader title={t('guide.commandEditor')} /> : <div className="flex items-center justify-between gap-3 mb-4 border-b pb-2"><h2 className="text-3xl font-bold">{t('guide.commandEditor')}</h2><GuideHelpButton section="twitch" /></div>}
      <iframe
        src="/se_command.html"
        title={t('guide.commandEditor')}
        className="w-full h-screen border-0"
      />
    </div>
  );
};

export default CommandEditor;
